<template>
  <div id="app">
    <keep-alive v-if="isRouterAlive">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
  export default {
    name: "App",
    provide() {
      return {
        reload: this.reload
      };
    },
    data() {
      return {
        isRouterAlive: true
      };
    },
    mounted() {
      //获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
      // var info = navigator.userAgent;
      // //通过正则表达式的test方法判断是否包含“Mobile”字符串
      // var isPhone = /mobile/i.test(info);
      // console.log(isPhone)
      // if(!isPhone){
      //   document
      //   .querySelector("#app")
      //   .setAttribute("style", "max-width: 375PX;margin-left: auto;margin-right: auto;");
      // }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      }
    }
  }
</script>
<style>
  /* #app {
    max-width: 375PX;
    margin-left: auto;
    margin-right: auto;
  } */

  /* @media only screen and (min-device-width : 375px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio: 2) {
    #app {
      max-width: inherit;
    }
  } */
</style>